import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BuscarPersona } from 'src/app/model/persons/buscarpersona.model';
import { AgregarPersona } from '../../app/model/persons/agregarpersona.model';
import { BuscarDatosPersona } from '../../app/model/persons/buscardatos.model';

@Injectable({
  providedIn: 'root'
})
export class PersonaService {

  endpoint = environment.apiUrl + 'Personas/persona/';
  endpointreportes = environment.apiUrl + 'Reportes/persona/';

  //endpoint = 'https://localhost:54640/' + 'persona/';  //aqui A201
  // endpointreportes = 'https://localhost:5210/' + 'persona/';

  httpOptions = {};

  constructor(private http: HttpClient) {
  }

  buscar(values: BuscarPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}buscar`,
      JSON.stringify(values)
    );
  }

   buscarPersonasConteos(values: BuscarPersona): Observable<any> {
    return this.http.post<any>(
      this.endpoint + 'obtenerTotalPersonas',
      JSON.stringify(values)
    );
  }
 
  reporteGeneral(values: any, tipoPersona: number): Observable<any> {
    let path = tipoPersona == 1 
      ? 'empleadogeneral' : tipoPersona == 2 ? 'clientegeneral' : 'relacionadageneral';
    return this.http.post<any>(
      `${this.endpointreportes}${path}`,
      JSON.stringify(values)
    );
  }
  
  buscarReporteClientes(values): Observable<any> {
		let result = this.http.post<any>(
			`${this.endpointreportes}reporte-clientes`,
			JSON.stringify(values)
		);
		return result;
	}

  guardar(values: AgregarPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}`,
      JSON.stringify(values)
    );
  }

  obtener(values: any): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}obtener`,
      JSON.stringify(values)
    );
  }

  obtenerRelacionadas(values: BuscarDatosPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}obtenerpersonasrealcionadas`,
      JSON.stringify(values)
    );
  }
  
  modificarPersona(values: AgregarPersona): Observable<any> {
    return this.http.put<any>(
      `${this.endpoint}`,
      JSON.stringify(values)
    );
  }

  generarRFC(values: AgregarPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}generarrfc`,
      JSON.stringify(values)
    );
  }

  buscarHRiesgo(values: any): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}buscarHRiesgo`,
      JSON.stringify(values)
    );
  }

  actualizarRiesgo(values: any): Observable<any> {
    return this.http.put<any>(
      `${this.endpoint}actualizarRiesgo`,
      JSON.stringify(values)
    );
  }

  buscarPersonaCasoManual(values: BuscarPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}buscarpersonaCasoManual`,
      JSON.stringify(values)
    );
  }
  
  guardarPersonaReportar(values: AgregarPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}guardarpersonareportar`,
      JSON.stringify(values)
    );
  }

  guardarPersonaBaseReportar(values: AgregarPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}guardarpersonabasereportar`,
      JSON.stringify(values)
    );
  }
  
  obtenerRelacionadasCaso(values: BuscarDatosPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}obtenerpersonasrelacionadascaso`,
      JSON.stringify(values)
    );
  }

  eliminarPersonaReportar(values: AgregarPersona): Observable<any> {
    return this.http.post<any>(
      `${this.endpoint}eliminarpersonareportar`,
      JSON.stringify(values)
    );
  }
  
  guardarBeneficiariosControladores(values: any[]): Observable<any> {
    return this.http.post(
      `${this.endpoint}guardarBeneficiariosControladores`,
       JSON.stringify(values)
    );
  }
}
